import StockTakeListingContainer from "./stockTakeListing.container";

export default StockTakeListingContainer;
